import React, { Fragment } from 'react';
import { theme, css, HEADER_HEIGHT, TABBAR_HEIGHT, isMVP } from 'constants';
import { lang } from 'lang';

import { FlatList, View, Scene, AppHeader, Link, Text } from 'core';
import ChatListItem from './chat_list_item';

import * as actions from 'actions';

const styles = css({
  header: {
    flexDirection: 'row-reverse',
    paddingHorizontal: 10,
    backgroundColor: 'white',
    justifyContent: 'space-between',
    borderColor: theme.gray_color_lighten(0.2),
    borderBottomWidth: theme.hairline
  },
  btn: {
    height: 50,
    justifyContent: 'center'
  }
});
const ListHeader = ({ is_groups }) =>
  !isMVP || is_groups ? (
    <View style={styles.header}>
      {is_groups ? (
        <Fragment>
          <Link style={styles.btn} selected title={lang.JOIN_GROUP} onPress={actions.clickJoinGroup} />
          <Link style={styles.btn} selected title={lang.CREATE_GROUP} onPress={actions.clickNewGroup} />
        </Fragment>
      ) : (
        <Link style={styles.btn} selected title={lang.NEW_MESSAGE} onPress={actions.clickNewGroup} />
      )}
    </View>
  ) : null;

const keyExtractor = item => item.id;
const ChatList = ({ is_groups, list, selected, user }) => (
  <Scene style={{ backgroundColor: 'white' }}>
    <AppHeader show_connecting title={is_groups ? lang.GROUPS : lang.MESSAGES} />
    <FlatList
      data={list}
      keyExtractor={keyExtractor}
      ListHeaderComponent={<ListHeader is_groups={is_groups} />}
      renderItem={({ item }) => <ChatListItem selected={item.id === selected} item={item} user={user} />}
      ListEmptyComponent={() => emptyList(is_groups)}
    />
  </Scene>
);

const emptyList = is_groups => (
  <View style={{ margin: 20, marginTop: 100, alignItems: 'center' }}>
    {is_groups ? (
      <Fragment>
        <Text style={{ fontSize: theme.font_xl, marginBottom: 20, color: theme.gray_color_lighten(0.4) }}>{lang.CLICK_CREATE_GROUP}</Text>
        <Text style={{ fontSize: theme.font_xl, color: theme.gray_color_lighten(0.4) }}>{lang.CLICK_JOIN_GROUP}</Text>
      </Fragment>
    ) : (
      <Text style={{ fontSize: theme.font_xl, marginBottom: 20, color: theme.gray_color_lighten(0.4) }}>{lang.NO_PM_CHATS}</Text>
    )}
  </View>
);

export default ChatList;



// WEBPACK FOOTER //
// ./src/components/left/chat_list.js